import React, { useEffect } from 'react';
import styles from './Settings.module.css';
import { Switch, Slider } from '@mui/material';
import Sidebar from '../Sidebar/Sidebar';
import speechManager from '../../services/speechManager';

const Settings = ({ 
  isOpen, 
  onClose, 
  onAutoStartMicChange, 
  isSplitView, 
  onSplitViewChange 
}) => {
  const [autoStartMic, setAutoStartMic] = React.useState(
    localStorage.getItem('autoStartMic') === 'true'
  );
  const [speechRate, setSpeechRate] = React.useState(
    parseFloat(localStorage.getItem('speechRate')) || 1
  );

  useEffect(() => {
    localStorage.setItem('autoStartMic', autoStartMic);
    if (onAutoStartMicChange) {
      onAutoStartMicChange(autoStartMic);
    }
  }, [autoStartMic, onAutoStartMicChange]);

  useEffect(() => {
    localStorage.setItem('speechRate', speechRate);
    if (speechManager.synth) {
      speechManager.setRate(speechRate);
    }
  }, [speechRate]);

  return (
    <Sidebar
      isOpen={isOpen}
      onClose={onClose}
      title="Settings"
    >
      <div className={styles.settingsList}>
        <div className={styles.settingItem}>
          <div className={styles.settingInfo}>
            <h3 className={styles.settingTitle}>Auto-start Microphone</h3>
            <p className={styles.settingDescription}>
              Automatically start recording after assistant finishes speaking
            </p>
          </div>
          <Switch
            checked={autoStartMic}
            onChange={(e) => setAutoStartMic(e.target.checked)}
            color="primary"
          />
        </div>

        <div className={styles.settingItem}>
          <div className={styles.settingInfo}>
            <h3 className={styles.settingTitle}>Split View</h3>
            <p className={styles.settingDescription}>
              Show messages beside the canvas instead of a sidebar
            </p>
          </div>
          <Switch
            checked={isSplitView}
            onChange={(e) => onSplitViewChange(e.target.checked)}
            color="primary"
          />
        </div>

        <div className={styles.settingItem}>
          <div className={styles.settingInfo}>
            <h3 className={styles.settingTitle}>Speech Rate</h3>
            <p className={styles.settingDescription}>
              Adjust assistant's speaking speed
            </p>
          </div>
          <div className={styles.sliderContainer}>
            <Slider
              value={speechRate}
              onChange={(_, value) => setSpeechRate(value)}
              min={0.5}
              max={2}
              step={0.1}
              valueLabelDisplay="off"
              sx={{ width: '140px' }}
            />
            <span className={styles.sliderValue}>{speechRate}x</span>
          </div>
        </div>
      </div>
    </Sidebar>
  );
};

export default Settings;
